import { Auth } from 'aws-amplify';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SignInPage } from '../../components/alliance/sign-in-page';
import { AuthContext } from '../../contexts/auth-context';
import { captureError } from '../../utils/capture-error';
import { consumeSessionExpired } from '../../utils/session-expired';
import { getSignInContent } from './sign-in-content';

/**
 * The Sign In page. Sign in goes to the Cognito Hosted UI; a failure to
 * start it is reported and shown on the button instead of failing silently.
 */
export function SignIn() {
  // Context
  const { state } = React.useContext(AuthContext);
  // State
  const [expired] = React.useState(consumeSessionExpired);
  const [content] = React.useState(() => getSignInContent());
  // Hooks
  const navigate = useNavigate();

  React.useEffect(() => {
    if (state.user !== undefined) {
      navigate('/home');
    }
  }, [state.user, navigate]);

  // Forgot Password Link
  const linkForForgot = `https://${process.env.REACT_APP_AWS_DOMAIN}/forgotPassword?client_id=${process.env.REACT_APP_AWS_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_AWS_REDIRECT_SIGN_IN}`;

  const handleSignIn = async () => {
    try {
      await Auth.federatedSignIn();
    } catch (error) {
      captureError({ data: { error } });
      throw error;
    }
  };

  return (
    <SignInPage
      onSignIn={handleSignIn}
      forgotPasswordHref={linkForForgot}
      // Contracting's own sign-up route (same tab)
      signUpHref="/sign-up/the-alliance"
      notice={expired ? 'expired' : null}
      photo={content.photo}
      quote={content.quote}
    />
  );
}
